<template>
    <b-field position="is-centered" class="search-box">
        <b-input :size="size" @keyup.native.enter="search" v-model="q" placeholder="Search..." type="search">
        </b-input>
        <div class="control">
            <b-button :size="size" @click="search" class="button is-danger">
                <span class="icon">
                    <object :id="imgid" type="image/svg+xml" :data="img" :alt="title" class="search-img"></object>
                    <!-- <img :src="img" alt="" :alt="title" class="search-img"> -->
                </span>
            </b-button>
        </div>
    </b-field>
</template>

<script>
    export default {
        props: ['size'],
        data() {
            return {
                q: null,
                imgid: 'img-' + this._uid,
                img: this.getMaterialUrl('search-20190525.svg'),
            };
        },
        mounted() {
            let target = '#' + this.imgid;
            let $ob = $(target);
            $ob.on("load", function () {
                let svgDoc = $ob[0].contentDocument;
                // console.log("load svgDoc", svgDoc);
                if (svgDoc) {
                    let $svgDoc = $(svgDoc) ;
                    let $svg = $svgDoc.find(".cls-1");
                    $svg.css('fill', "#fff");
                    // $svgDoc.find("svg").css('cursor', "pointer");
                }
            });
        },
        methods: {
            search() {
                console.log(this.q);
                this.$router.push({
                    name: 'Materials',
                    query: {
                        q: this.q
                    }
                });
            }
        },
        components: {}
    };
</script>

<style scoped lang="scss">
</style>